import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import getSymbolFromCurrency from "currency-symbol-map";
import ShoppingCartSharpIcon from "@mui/icons-material/ShoppingCartSharp";
import { CartModal } from "@components";
import { updateCart } from "@redux/booking/slice";
import "../../App.css";

export default function CartsView() {
  const dispatch = useDispatch();
  const { cartDetails } = useSelector((store) => store.bookingReducer);

  const [state, setState] = useState({
    cartModal: false,
  });

  const prices =
    cartDetails && cartDetails?.length ? cartDetails.map((a) => a?.amount) : "";
  const totalPrice =
    cartDetails && cartDetails?.length && prices
      ? prices.reduce((acc, curr) => acc + curr)
      : "";

  let currencyType = cartDetails?.length ? cartDetails[0]?.currency : "EUR";
  let currencySymble =
    currencyType?.length > 1
      ? getSymbolFromCurrency(currencyType)
      : currencyType;

  const closeModal = () => {
    setState((prev) => ({ ...prev, cartModal: false }));
  };

  useEffect(() => {
    let localdata = JSON.parse(localStorage.getItem("LocalCartData"));
    if (localdata?.length && !cartDetails?.length) {
      dispatch(updateCart({ localdata: localdata, localSave: true }));
    }
  }, [cartDetails]);

  return (
    <>
      {cartDetails?.length > 0 && totalPrice && currencySymble ? (
        <div
          onClick={() => setState((prev) => ({ ...prev, cartModal: true }))}
          className="w-auto h-[40px] rounded-full bg-primary flex flex-row items-center justify-around gap-x-2 px-2 hover:cursor-pointer hover:opacity-80"
        >
          <ShoppingCartSharpIcon sx={{ fontSize: "25px", color: "white" }} />
          <div className="w-auto min-w-[25px] px-[8px] flex items-center justify-center h-auto bg-btnTextColor border border-textColor rounded-full">
            <span className="text-[16px] font-semibold text-center">
              {cartDetails?.length}
            </span>
          </div>
          <div>
            <sup className="font-textColor lg:text-[11px] text-[9px] text-btnTextColor">
              {currencySymble}
            </sup>
            <span className="text-[16px] font-textColor text-btnTextColor">
              {Math.round(totalPrice)}
            </span>
          </div>
        </div>
      ) : (
        <></>
      )}
      <CartModal
        openModal={state.cartModal}
        closeModal={closeModal}
        addToCartData={cartDetails}
      />
    </>
  );
}
